<template>
	<div class="resetpassword">
		<v-header :goBackaf='true' :forgetPsw='true'></v-header>
		<span class="title" v-show="false">{{$t('forgetpassword.resetpassword')}}</span>
		<div class="pro_pic" v-show="false">
			<img src="../../../static/img/dp-logo.jpg" alt=" "/>
		</div>
		<el-main>
			<div class="pos_icon">
				<div class="icon"><img src="../../../static/img/login2/registeremail2.png" alt=""></div>
				<el-input
					:placeholder="$t('register.enterPsd')"
					v-model="respect"
					:type="resetPsw"
					maxlength="16"
					>				
				</el-input>
				<div class="eye" @click="eye('resetPsw')"><img src="../../../static/img/login2/registeremail3.png" alt=""></div>
			</div>
			<span class="danger" v-show="flag1">{{$t('changepassword.lessPsd')}}</span>
			<span class="danger" v-show="flag3">{{$t('changepassword.notPsd')}}</span>
			<div class="pos_icon">
				<div class="icon"><img src="../../../static/img/login2/registeremail2.png" alt=""></div>
				<el-input
					:placeholder="$t('register.againEnterPsd')"
					v-model="input1"
					:type="resetPswA"
					maxlength="16"
					>				
				</el-input>
				<div class="eye" @click="eye('resetPswA')"><img src="../../../static/img/login2/registeremail3.png" alt=""></div>
			</div>
			<br/>
			<p class="danger" v-show="flag2">{{$t('changepassword.notSamePsd')}}</p>
			<span class="danger" v-show="flag4">{{$t('register.notAgainPsd')}}</span>
		</el-main>
		<el-button type="danger" class="over" @click="complete">
			{{$t('forgetpassword.setpassword')}}
		</el-button>
	</div>
</template>
<script>
	import {updatePasswordByMobile} from '../../api/index.js'
	import {resetPsw2, areaCode} from '../../apiNew/index.js'
	import store from '../../store/store.js'
	import Qs from "qs";
	import header from '../../components/header';
	export default{
		name: "reset",
		data () {
			return{
				input1:'',
				respect:'',
				mobile:"",
				smscode:"",
				areaCode:"",
				flag1:false,
				flag2:false,
				flag3:false,
				flag4:false,
				resetPsw:'password',
				resetPswA:'password'			
			}
		},
		components:{
			"v-header":header
		},
		mounted(){
				this.smscode=this.$route.query.smsCode
				// console.log(this.smscode)
				this.mobile=this.$route.query.phone
				// console.log(this.mobile)
				this.areaCode=this.$route.query.areaCode
			},
		methods: {
			eye(type){
				switch (type){
					case 'resetPsw':
					if(this.resetPsw=='password'){
						this.resetPsw = 'text'
					}else{
						this.resetPsw = 'password'
					}
					break;
					case 'resetPswA':
					if(this.resetPswA=='password'){
						this.resetPswA = 'text'
					}else{
						this.resetPswA = 'password'
					}
					break;
				}
			},
			complete(){
				if(this.smscode!='isEmail'){
					if(this.flag1==false&&this.flag2==false&&this.input1.length>0&&this.respect.length>0){
						let params =  Qs.stringify({
							mobile:this.mobile,
							smsCode:this.smscode,
							password: this.respect,
							areaCode:this.areaCode
						})
							updatePasswordByMobile(params).then(res => {
							// console.log(res)
							this.$router.push({
				                name: "login",
				                query: {
				                  accessToken: localStorage.token,
				                  deviceCode: localStorage.codeId
				                }
			              	});
						}).catch(error => {
							console.log(error)
						})
					}else{
						if(this.respect.length==0){
							this.flag1=false;
							this.flag3=true;
						}
						if(this.input1.length==0){
							this.flag2=false;
							this.flag4=true;
						}
						
					}
				}else{
					// console.log("zheshiyouxiang")
					let params = Qs.stringify({
						areaCode:'',
						username:this.mobile,
						password: this.respect
					})
					resetPsw2(params)
					.then(res=>{
						// console.log("修改返回状态：",res.data.header.status)
						if(res.data.header.status==1000){
							this.$router.push({
				                name: "login",
				                query: {
				                  accessToken: localStorage.token,
				                  deviceCode: localStorage.codeId
				                }
			              	});
						}
						if(res.data.header.status==3027){
							this.$alert(res.data.header.message)
						}
					})
					.catch(err=>{
						console.log(err)
					})
				}
				
			}
		},
		watch: {
			respect(val){
				if(val.length>0&&val.length<6){
					this.flag1=true;
					this.flag3=false;
					this.flag4=false;
				}else{
					this.flag1=false
				}
			},
			input1(val){
				if(val!=this.respect){
					this.flag2=true
					this.flag3=false;
					this.flag4=false;
				}else{
					this.flag2=false;
					this.flag3=false;
					this.flag4=false;
				}
			}
		}
	}
</script>
<style>
.resetpassword .el-input input{
	border: 0;
	border-radius: 0;
	box-sizing: border-box;
	padding-left: 2.5rem;
	border-bottom: 1px solid #cccccc;
}
</style>
<style scoped>
/*.resetpassword-header{
	text-align: center;
	background-color: #0ca8e3;
	color: white;
	font-family: "微软雅黑";
	font-size: 20px;
	position: relative;
}
.resetpassword-header p{
	font-weight: bold;
	margin-top: 18px;
}*/
.resetpassword .el-main{
	margin-top: 30px;
}
/* .title{
  text-align: center;
  font-size: .75rem;
  display: block;
  color: #828282;
}
.logo{
	text-align: center;
	width: 50%;
	margin: 0 auto;
	margin-top: 8px;
}
.logo img{
	width: 100%;
}
.pro_pic{
	width: 100%;
	text-align: center;
	margin: 1rem 0;
} */

.el-main{
	padding: 0 20px;
}
.pos_icon{
	position: relative;
	width: 100%;
	height: 2.6rem;
	line-height: 2.6rem;
	margin-top: 20px;
}
.icon{
	position: absolute;
	z-index: 99;
	width: 2rem;
	height: 1.5rem;
	line-height: 1.5rem;
	border-right: 1px solid #cccccc;
	top: 0.5rem;
}
.icon img{
	width: 1rem;
	vertical-align: middle;
}
.eye{
	position: absolute;
	right: 0.5rem;
	top: 0.2rem;
}
.eye img{
	width: 1.2rem;
}

.danger{
	font-size: 0.625rem;
	margin-top: 5px;
	color: red;
}
.over{
	width: 72%;
	margin-left: 14%;
	font-size: 1rem;
	height: 2.6rem;
	line-height: 2.6rem;
	color: rgb(255,255,255);
	margin-top: 30px;
	border-radius: 1.3rem;
	background-image: linear-gradient(to right , #65d3e8, #7dc3f2);
	border: 0;
	padding: 0 0;
}
</style>


// WEBPACK FOOTER //
// src/m_page/login/resetpassword.vue